import {
  Box,
  Button,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { ChangeEvent, FC } from "react";
import { StatisticState } from "./Description";
import { Formik, FormikHelpers } from "formik";
import * as yup from "yup";
import "./style.css";

interface DescriptionFormProps {
  state: StatisticState;
  handleSubmitForm: (
    values: StatisticState,
    actions: FormikHelpers<StatisticState>
  ) => void;
}

export const DescriptionForm: FC<DescriptionFormProps> = ({
  state,
  handleSubmitForm,
}) => {
  const validationSchema = yup.object({
    totalWon: yup
      .string()
      .min(1, "It can't be less then 1")
      .required("Field is required"),
      previousWinner: yup.string().required("Field is required"),
      charitableDonation: yup
      .string()
      .min(1, "It can't be less then 1")
      .required("Field is required"),
      charity: yup
      .string()
      .min(1, "It can't be less then 1")
      .required("Field is required"),
      appDownload: yup
      .string()
      .min(1, "It can't be less then 1")
      .required("Field is required"),
  });

  return (
    <Formik
      initialValues={{
        totalWon: state.totalWon,
        previousWinner: state.previousWinner,
        charitableDonation: state.charitableDonation,
        charity: state.charity,
        appDownload: state.appDownload,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmitForm}
    >
      {({
        errors,
        touched,
        handleChange,
        handleSubmit,
        values,
      }) => (
        <Box>
          <Box className="fieldRow">
            <Typography className="fieldTitle">Total prizes won</Typography>
            <TextField
              className="textField"
              value={values.totalWon}
              onChange={handleChange("totalWon")}
              name="totalWon"
              size="small"
              error={
                errors.totalWon && touched.totalWon ? true : false
              }
              placeholder="£xxxk"
              variant="outlined"
            />
            {errors.totalWon && touched.totalWon && (
              <Box className="statisticErrorMessage">
                <Typography color="error">{errors.totalWon}</Typography>
              </Box>
            )}
          </Box>
          <Box className="fieldRow">
            <Typography className="fieldTitle">Previous Winners</Typography>
            <TextField
              className="textField"
              value={values.previousWinner}
              onChange={handleChange("previousWinner")}
              name="previousWinner"
              placeholder="xxx"
              size="small"
              error={
                errors.previousWinner && touched.previousWinner ? true : false
              }
              variant="outlined"
            />
            {errors.previousWinner && touched.previousWinner && (
              <Box className="statisticErrorMessage">
                <Typography color="error">{errors.previousWinner}</Typography>
              </Box>
            )}
          </Box>
          <Box className="fieldRow">
            <Typography className="fieldTitle">Charitable Donations</Typography>
            <TextField
              className="textField"
              value={values.charitableDonation}
              onChange={handleChange("charitableDonation")}
              name="charitableDonation"
              placeholder="£xxxk"
              size="small"
              error={
                errors.charitableDonation && touched.charitableDonation
                  ? true
                  : false
              }
              variant="outlined"
            />
            {errors.charitableDonation && touched.charitableDonation && (
              <Box className="statisticErrorMessage">
                <Typography color="error">
                  {errors.charitableDonation}
                </Typography>
              </Box>
            )}
          </Box>
          <Box className="fieldRow">
            <Typography className="fieldTitle">Charity</Typography>
            <TextField
              className="textField long"
              value={values.charity}
              onChange={handleChange("charity")}
              name="charity"
              size="small"
              placeholder="£xx,xxx.xx raised for our charity partners"
              error={errors.charity && touched.charity ? true : false}
              variant="outlined"
            />
            {errors.charity && touched.charity && (
              <Box className="statisticErrorMessage">
                <Typography color="error">{errors.charity}</Typography>
              </Box>
            )}
          </Box>
          <Box className="fieldRow">
            <Typography className="fieldTitle">App Donwloads so far</Typography>
            <TextField
              className="textField long"
              value={values.appDownload}
              onChange={handleChange("appDownload")}
              name="appDownload"
              size="small"
              placeholder="£xx,xxx.xx raised for our charity partners"
              error={
                errors.appDownload && touched.appDownload
                  ? true
                  : false
              }
              variant="outlined"
            />
            {errors.appDownload && touched.appDownload && (
              <Box className="statisticErrorMessage">
                <Typography color="error">{errors.appDownload}</Typography>
              </Box>
            )}
          </Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Save changes
          </Button>
        </Box>
      )}
    </Formik>
  );
};
